export const setMataUrl = url => ({
    type: 'MATA_URL',
    url: url
});

const initialState = '';

export default (state = initialState, action = {}) => {
    if (action.type === 'MATA_URL') {
        state = action.url;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/mataUrl.js